import { $ } from '../util/view';
import { kebabCase } from '../util/string';
import { parentQuerySelector } from '../util/dom';
const switchNav = (container, navLink) => {
    const current = container.querySelector('.mol-ads-cmp--tab.active');
    if (current) {
        current.classList.remove('active');
    }
    navLink.parentNode.classList.add('active');
};
const switchBody = (container, navLink) => {
    const current = container.querySelector('.mol-ads-cmp--tab-body.active');
    if (current) {
        current.classList.remove('active');
    }
    const id = navLink.dataset.current;
    const body = id && document.getElementById(id);
    if (body) {
        body.classList.add('active');
    }
};
const switchTabs = (event) => {
    event.preventDefault();
    const target = event.target;
    if (!target) {
        event.stopImmediatePropagation();
        return;
    }
    const container = parentQuerySelector(target, '.mol-ads-cmp--tabs-container');
    if (!container) {
        throw new Error('Can\'t find tab container');
    }
    switchNav(container, target);
    switchBody(container, target);
};
export default function ({ onSwitch = () => { }, items }) {
    const settings = ($('div', { class: 'mol-ads-cmp--tabs-container' }, [
        $('ul', { class: 'mol-ads-cmp--tabs' }, items.map(({ title, onSelect = () => { } }, index) => $('li', {
            class: {
                'active': index === 0,
                'mol-ads-cmp--tab': true
            }
        }, [
            $('a', {
                'class': 'mol-ads-cmp--tab-trigger',
                'data-current': kebabCase(title),
                'data-index': index,
                'href': `#${kebabCase(title)}`
            }, title)
                .click([switchTabs, onSwitch])
                .click(onSelect)
        ]))),
        ...items.map((item, index) => $('div', {
            class: {
                'active': index === 0,
                'mol-ads-cmp--tab-body': true
            },
            id: kebabCase(item.title)
        }, item.body))
    ]));
    return Object.assign(settings, {
        switchTabs: () => {
            const event = new CustomEvent('click', { cancelable: false });
            onSwitch(event);
            const tab = settings.raw.querySelector('.mol-ads-cmp--tab:not(.active) .mol-ads-cmp--tab-trigger');
            if (tab) {
                switchNav(settings.raw, tab);
                switchBody(settings.raw, tab);
            }
        }
    });
}
